module.exports = __webpack_public_path__ + "media/images/wave-7dbbc6f4e9c151a3dfaa8ec0337f4d74.png";